// Moved from the W0 spike (Web/spikes/automerge-interop). Heads as the Swift stores them (AutomergeSupport.swift `Heads`):
// each change hash as 64 lowercase hex
// digits, sorted, concatenated with no separator. JS Automerge already gives hashes as lowercase hex.
import * as A from "@automerge/automerge";

export function encodeHeads(heads: string[]): string {
  return [...heads].map((h) => h.toLowerCase()).sort().join("");
}

/** Throws on a length that isn't a multiple of 64 or a non-hex digit, as `Heads.decode` does. */
export function decodeHeads(encoded: string): string[] {
  if (encoded.length % 64 !== 0 || !/^[0-9a-fA-F]*$/.test(encoded)) throw new Error("Invalid heads encoding");
  const out: string[] = [];
  for (let i = 0; i < encoded.length; i += 64) out.push(encoded.slice(i, i + 64).toLowerCase());
  return out;
}

/** `Heads.decode(_:in:)`: the heads if the document has every one of them (and there's at least one). */
export function decodeHeadsIn(encoded: string, doc: A.Doc<unknown>): string[] | null {
  let heads: string[];
  try {
    heads = decodeHeads(encoded);
  } catch {
    return null;
  }
  if (heads.length === 0 || !A.hasHeads(doc, heads)) return null;
  return heads;
}
